import React, { useEffect, useState } from 'react';
import { Modal } from 'antd-mobile';
import HeaderVipImg from '@/assets/images/vip/header_vip.png';
import HeaderNonVipImg from '@/assets/images/vip/header_non_vip.png';

import QrCodeImg from '@/assets/images/vip/qrcode.png';
import SimpleQrcode from '@/assets/images/vip/small_qrcode.png';
import FeatureDiffImg from '@/assets/images/vip/feature_diff.png';
import TopBg from '@/assets/images/vip/top_bg.png';
import envelopeImg from '@/assets/images/vip/envelope.png';
// import BtnTipsNoVip from '@/assets/images/vip/btn_tips.png';
// import BtnTipsVip from '@/assets/images/vip/btn_tips.png';

import VipBookCoverImg from '@/assets/images/vip/vip-book-cover.png';
import VipVoiceCoverImg from '@/assets/images/vip/vip-voice-cover.png';
import VipWriteCoverImg from '@/assets/images/vip/vip-write-cover.png';

import { isApp, isWechat, compareVersion } from '../../utils/EnvUtils';
import DownLoad from './DownLoad';
import VipPanel from '../../components/vip/VipPanel';

import { JsBridge, messageMethodIsSupport } from '../../utils/JsBridge';
import VConsole from 'vconsole';

function VipSale() {
  const [notInWxText, setNotInWxText] = useState('添加客服');
  const [appVersion, setAppVersion] = useState<string>("");
  const [isVip, setIsVip] = useState<boolean>();
  const [isPermanentVip, setIsPermanentVip] = useState<boolean>();

  const [clickCount, setClickCount] = useState(0); // Click count state
  const [showVersion, setShowVersion] = useState(false); // State to control version display

  useEffect(() => {
    //判断环境隐藏
    if (window.location.host === 'test.deerbook.cn') {
      const vConsole = new VConsole();
      return () => vConsole.destroy();
    }
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'wxPayResult') {
        console.log('wxPayResult: result', event.data.result);
        refreshUser();
      }
    };
    window.addEventListener('message', handleMessage);
  }, []);

  const refreshUser = () => {

    const isVipMatch = navigator.userAgent.match(/isVip_(true|false)/);
    const isPermanentVipMatch = navigator.userAgent.match(/isPermanentVipUser_(true|false)/);
    const appVersionMatch = navigator.userAgent.match(/version_([\d\\.]+)/);

    const isVipFromApp = isVipMatch ? isVipMatch[1] === 'true' : undefined;
    const isPermanentVipFromApp = isPermanentVipMatch ? isPermanentVipMatch[1] === 'true' : undefined;
    const appVersion = appVersionMatch ? appVersionMatch[1] : "";

    setIsVip(isVipFromApp);
    setIsPermanentVip(isPermanentVipFromApp);
    setAppVersion(appVersion);

    const userAgent = navigator.userAgent;
    console.log({ isVipFromApp, isPermanentVipFromApp, appVersion, userAgent });
  }

  useEffect(() => {
    refreshUser()
  }, []);

  useEffect(() => {
    document.title = '解锁奇鹿英语会员';

    // 根据APP内，方法是否支持，判断文案内容
    if (
      isWechat() ||
      (typeof window !== 'undefined' && window?.openCustomerServiceChat)
    ) {
      setNotInWxText('添加客服');
    } else {
      setNotInWxText('添加客服');
    }
  }, []);

  const handleClickHeader = () => {
    setClickCount(prevCount => {
      const newCount = prevCount + 1;
      if (newCount >= 10) {
        setShowVersion(true); // Show version number
        setTimeout(() => {
          setShowVersion(false); // Hide version number after 1 second
        }, 500); // 1000ms = 1 second
        return 0; // Reset click count
      }
      return newCount;
    });
  };

  function openModal() {
    Modal.show({
      content: (
        <div className='flex flex-col items-center'>
          <img src={QrCodeImg} alt='' className='w-[210px] h-[270px]' />
          {/* <div className='mt-[20px]'>微信中长按识别二维码添加客服购买</div> */}
        </div>
      ),
      closeOnMaskClick: true,
    });
  }

  function handleShare() {
    try {
      if (isWechat()) {
        window.location.href =
          'https://work.weixin.qq.com/kfid/kfc5899b8ee7e2d3fef';
      } else if (messageMethodIsSupport('openCustomerServiceChat')) {
        JsBridge.openCustomerServiceChat({ sourceFrom: 'H5' });
      } else if (messageMethodIsSupport('shareWeb')) {
        JsBridge.shareWeb({ sourceFrom: 'H5' });
      } else {
        openModal();
        setTimeout(() => {
          window.location.href =
            'https://work.weixin.qq.com/kfid/kfc5899b8ee7e2d3fef';
        }, 100);
      }
    } catch (error) {
      console.error('error:', error);
    }
  }

  return (
    <div  style={{
      background: 'linear-gradient(180deg, #FFD540 0%, #ffffff 12%, #ffffff 100%)',
    }} className='flex items-center flex-col'>
      {showVersion && clickCount && (
        <div className='absolute top-0 right-0 p-2 rounded'>
          0.0.2
        </div>
      )}
      <img alt='' src={isVip ? HeaderVipImg : HeaderNonVipImg} className='w-full' onClick={handleClickHeader} />
      <div
        style={{
          background: `url(${TopBg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'center',
        }}
        className='rounded-[6px] w-[350px] h-[500px] flex flex-col items-center mt-[-74px]'
      ></div>

      <div
        style={{
          background: `url(${envelopeImg})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
        className='rounded-[6px] w-[340px] h-[120px] flex items-end justify-between mt-[-130px] pb-[8px]'
      >
        <div className='ml-[8px] mb-[8px] pr-[8px] border-r-2 border-dashed border-[#C7AC85]'>
          <img alt='' src={SimpleQrcode} className='w-[80px] h-[80px]' />
        </div>
        <div className={`text-[14px] text-center flex flex-col flex-grow items-center mr-[10px]`}>
          <div className="text-[#304270] text-center text-[16px] font-medium">{isVip ? '扫码加官方客服咨询' : '扫码加官方客服，获取vip权限'}</div>
          <div
            style={{
              background: 'linear-gradient(90deg, #FF5DA1 0%, #FF5C16 100%)',
            }}
            onClick={handleShare}
            className='w-[154px] h-[32px] rounded-full text-[#ffffff] flex items-center justify-center mb-[10px] mt-[6px]'
          >
            {isWechat() ? '添加客服' : notInWxText}
          </div>
        </div>
      </div>

      <div>
        <img alt='' src={FeatureDiffImg} className='w-[360px] mr-[4px]' />
      </div>

      <div className='flex items-center flex-col mt-[46px]'>
        <div className='flex items-center flex-col'>
          <div className='text-[36px] text-[#4E2F12] font-pingfang font-semibold leading-[37px]'>
            10000+ 海量学习绘本
          </div>
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            专业海量资源免费读，持续更新
          </div>
          <img alt='' src={VipBookCoverImg} className='w-full' />
        </div>

        <div className='flex items-center flex-col mt-[28px]'>
          <div className='text-[36px] text-[#4E2F12] font-pingfang font-semibold leading-[37px]'>
            AI 实时纠音反馈
          </div>
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            正确率、语速、语调等立体打分
          </div>
          <img alt='' src={VipVoiceCoverImg} className='w-full' />
        </div>

        <div className='flex items-center flex-col mt-[28px]'>
          <div className='text-[36px] text-[#4E2F12] font-pingfang font-semibold leading-[37px]'>
            听说读写 全面进阶
          </div>
          <div className='text-[16px] text-[#4E2F12] mt-[16px]'>
            自然拼读、填词、句子全覆盖
          </div>
          <img alt='' src={VipWriteCoverImg} className='w-full' />
        </div>
      </div>
      {
        !isApp() ? (
          <DownLoad />
        ) : (
          compareVersion(appVersion, "3.9.0") && (isPermanentVip === false) ? (
            <>
              <VipPanel isNeedUpdate={false} />
              <div className='h-[150px]'></div>
            </>
          ) : null
        )
      }
      <div className='h-[50px]'></div>

    </div>
  );
}

export default VipSale;
